var React = require('react');

function Youtube (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M24 46.9266C11.338 46.9266 1.07336 36.6625 1.07336 24.0005V24C1.07336 11.338 11.338 1.07336 24 1.07336C36.662 1.07336 46.9266 11.338 46.9266 24C46.9266 36.662 36.662 46.9266 24 46.9266Z","stroke":"#333333","strokeWidth":"1.41111","strokeMiterlimit":"10","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M21.5053 28.4401V19.4259L28.3416 23.9325L21.5053 28.4401ZM35.8675 19.5923C35.8675 17.6152 34.2666 16.0132 32.2899 16.0132H15.5084C13.5312 16.0132 11.9303 17.6152 11.9303 19.5923V29.1893C11.9303 31.1659 13.5312 32.7685 15.5084 32.7685H32.2899C34.2666 32.7685 35.8675 31.1659 35.8675 29.1893V19.5923Z","fill":"#333333","key":1})]);
}

Youtube.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = Youtube;

Youtube.default = Youtube;
